(() => {
  if (window.__mmShowcaseMotionRefresh) {
    window.__mmShowcaseMotionRefresh();
    return;
  }

  const sections = new Set();
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const moreContrast = window.matchMedia('(prefers-contrast: more)');
  const dataSaver = navigator.connection?.saveData === true;
  const observer = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) entry.target.classList.add('mm-inview');
        }
      }, { threshold: 0.12 })
    : null;
  let scheduled = false;

  const clamp = (value) => Math.max(0, Math.min(1, value));
  const motionOff = () => reducedMotion.matches || moreContrast.matches || dataSaver;

  function paint(section) {
    const box = section.getBoundingClientRect();
    if (box.bottom < -100 || box.top > window.innerHeight + 100) return;

    const progress = clamp((window.innerHeight - box.top) / (window.innerHeight + box.height));
    const offset = 0.5 - progress;

    if (section.classList.contains('mm-product-card')) {
      section.style.setProperty('--mm-photo-scale', (1.08 + offset * 0.08).toFixed(3));
      section.style.setProperty('--mm-photo-y', `${Math.round(offset * 32)}px`);
      section.style.setProperty('--mm-render-y', `${Math.round(offset * 64)}px`);
    } else if (section.classList.contains('mm-engineering')) {
      section.style.setProperty('--mm-sea-scale', (1.06 + offset * 0.06).toFixed(3));
      section.style.setProperty('--mm-sea-y', `${Math.round(offset * 24)}px`);
      section.style.setProperty('--mm-actuator-y', `${Math.round(offset * 72)}px`);
      section.style.setProperty('--mm-title-y', `${Math.round(offset * 24)}px`);
    }
  }

  function update() {
    scheduled = false;
    if (motionOff()) return;
    for (const section of sections) {
      if (!section.isConnected) {
        sections.delete(section);
        continue;
      }
      paint(section);
    }
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(update);
  }

  function refresh() {
    document.querySelectorAll('[data-mm-showcase-motion]').forEach((section) => {
      if (sections.has(section)) return;
      sections.add(section);
      observer?.observe(section);
      section.addEventListener('focusin', () => section.classList.add('mm-inview'));
    });

    for (const section of sections) {
      if (!section.isConnected) {
        sections.delete(section);
        continue;
      }
      section.classList.toggle('mm-motion-ready', !motionOff() && observer !== null);
      if (motionOff()) {
        section.classList.remove('mm-inview');
        ['--mm-photo-scale', '--mm-photo-y', '--mm-render-y', '--mm-sea-scale', '--mm-sea-y', '--mm-actuator-y', '--mm-title-y']
          .forEach((name) => section.style.removeProperty(name));
      } else if (!observer) {
        section.classList.add('mm-inview');
      } else {
        const box = section.getBoundingClientRect();
        if (box.top < window.innerHeight * 0.88 && box.bottom > 0) section.classList.add('mm-inview');
      }
    }
    schedule();
  }

  window.__mmShowcaseMotionRefresh = refresh;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, { once: true });
  else refresh();
  document.addEventListener('shopify:section:load', refresh);
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  reducedMotion.addEventListener('change', refresh);
  moreContrast.addEventListener('change', refresh);
})();
